import React from 'react'
import { SxProps, IconButton } from '@mui/material'
import { J2UploadToCloud } from '@e3dc-react/icons'
import useModals from 'src/Hooks/useModals'
import { DownloadCategoryItemDto } from '../dto'

interface Props {
  parent: DownloadCategoryItemDto
  sx?: SxProps
}

/**
 * Button to upload a file
 */
const UploadFileButton: React.FC<Props> = ({ parent, sx }) => {
  const { openUploadFileDialog } = useModals()

  const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation()
    openUploadFileDialog({ parent })
  }

  return (
    <IconButton sx={sx} onClick={onClick} data-qa={'iconButton-upload-file'}>
      <J2UploadToCloud />
    </IconButton>
  )
}

export default UploadFileButton
